export default __webpack_public_path__ + "static/media/masterbed1.e9f34e3a.jpg";